import styled from 'styled-components';
import {
  getColor,
  getSpace,
  gridContainer,
  maxContentWidth,
  mq,
  px2rem,
  setGridColumns
} from '@stylesheets/tools';

const StyledListView = styled.div`
  width: 100%;
  
  ${mq('l')} {
    padding-top: ${px2rem('150px')};
  }
  
  .list-view__grid-wrapper {
    background: ${getColor('white')};
  }
  
  .list-view__grid {
    grid-template-rows: 1fr;
    ${maxContentWidth('1440px')}
    ${gridContainer()}
    ${setGridColumns('1fr', 12)}

    ${mq('l')} {
      padding: 0 ${getSpace('l')};
    }
  }

  .list-view__filter-modal {
    position: sticky;
    top: 0;
    z-index: 4;
  }
  
  .list-view__filter {
    display: none;
    align-self: start;
    position: sticky;
    top: 0;
    padding-right: 20px;
    grid-column: 1 / span 4;
    max-width: 550px;
    z-index: 2;
    padding-top: calc(${getSpace('xl')} + ${getSpace('xxl')});

    ${mq('l')} {
      display: block;
    }
  }

  .list-view__list {
    grid-column: 1 / -1;

    ${mq('l')} {
      grid-column: 5 / -1;
    }
  }
`;

export default StyledListView;
